import { useEffect, useState } from "react";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

// Types de revenus créés automatiquement (par immeuble, Régularisation, Autres revenus) : nom affiché modifiable
export const TypesRevenusAuto = () => {
  const [liste, setListe] = useState(null);
  const [envoi, setEnvoi] = useState(false);
  useEffect(() => { api.get("/types-revenus-auto").then((r) => setListe(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  if (!liste) return <Loader2 className="h-5 w-5 animate-spin text-slate-400" />;
  const enregistrer = async () => {
    setEnvoi(true);
    try {
      await api.put("/types-revenus-auto", { noms: Object.fromEntries(liste.map((l) => [l.auto, l.nom])) });
      toast.success("Noms enregistrés : le tableau de bord et les rapports les utilisent");
    } catch (e) { toast.error(errMsg(e)); } finally { setEnvoi(false); }
  };
  return (
    <div className="mt-6 border-t border-slate-100 pt-4" data-testid="revenus-auto">
      <p className="text-sm font-medium text-slate-700">Types automatiques</p>
      <p className="mb-3 text-xs text-slate-500">Créés par l'application selon l'immeuble du dépôt. Le classement ne change pas : seul le nom affiché change. Laissez vide pour garder le nom d'origine.</p>
      <div className="space-y-2">
        {liste.map((l, i) => (
          <div key={l.auto} className="grid grid-cols-1 md:grid-cols-[320px_1fr] items-center gap-2" data-testid={`revenu-auto-${i}`}>
            <span className="truncate text-sm text-slate-600" title={l.auto} data-testid={`revenu-auto-${i}-origine`}>{l.auto}</span>
            <Input value={l.nom} placeholder={l.auto} maxLength={80} onChange={(e) => setListe(liste.map((x, j) => (j === i ? { ...x, nom: e.target.value } : x)))} data-testid={`revenu-auto-${i}-nom`} />
          </div>
        ))}
      </div>
      <Button size="sm" onClick={enregistrer} disabled={envoi} className="mt-3 bg-emerald-700 hover:bg-emerald-800" data-testid="revenus-auto-enregistrer">
        {envoi ? <Loader2 className="h-3.5 w-3.5 mr-1 animate-spin" /> : <Save className="h-3.5 w-3.5 mr-1" />}Enregistrer les noms
      </Button>
    </div>
  );
};
